module.exports = __webpack_public_path__ + "img/confirmassets.6e2c0b3d.svg";